<div class="menu-activity-bar">
   <div class="breadcrumbs button-ish" *ngIf="!(search.searchActive$ | async) else searching">
      <ng-container *ngIf="search.showSearch">
         <span 
            (mouseenter)="searchHover = true" 
            (mouseleave)="searchHover = false" 
            (click)="search.searchActive$.next( true )"
            class="common-mr1ex common-pointer"
         >
            <mat-icon class="common-vamiddle">search</mat-icon>
            <span *ngIf="searchHover" @slideIn class="slideable"> Search</span>
         </span>
      </ng-container>

      <ng-container *ngFor="let crumb of breadcrumbs.breadcrumbs; first as first">
         <span *ngIf="!first"> > </span>
         <a class="breadcrumb" (click)="breadcrumbs.goToCrumb( crumb )">{{crumb.label | uppercase}}</a>
      </ng-container>
   </div>

   <lib-account-select *ngIf="!breakpoints.xsmall"></lib-account-select>
</div>

<ng-template #searching>
   <mat-form-field class="activityfield" floatLabel="never">
      <mat-label>Search {{breadcrumbs.breadcrumbs[0]}}</mat-label>
      <mat-icon matPrefix class="common-mr2ex">search</mat-icon>
      <input #searchInput matInput [formControl]="search.text" (keydown.esc)="search.softReset()" (keyup.enter)="enterKeyUp()" />
      <button mat-icon-button matSuffix (click)="search.softReset()" [matTooltip]="breakpoints.large ? 'Esc' : ''">
         <mat-icon>clear</mat-icon>
      </button>
   </mat-form-field>
</ng-template>
